<div class="chart-and-inputs">
  <div class="chart-wrapper">
    <!-- Reserved for chart if needed -->
  </div>

  <div class="aligned-inputs">
    <div class="label-col">
      <div class="row-label">Year</div>
      <div class="row-label">Opportunity %</div>
      <div class="row-label">Yearly Sales ($)</div>
      <div class="row-label">Notes</div>
    </div>

    <div class="input-cols" [ngStyle]="{
    'grid-template-columns': 'repeat(' + (yearRange.length+1) + ', 1fr)'
  }">
      <div class="input-col"></div>
      <div class="input-col" *ngFor="let year of yearRange;let i=index">
        
        <div><strong>{{years[i+1]}}</strong></div>

        <!-- Opportunity % -->
        <input  *ngIf="form.get('opportunity_' + year)" type="number" [formControl]="getControl('opportunity_' + year)" (blur)="onOpportunityChange(year)"
          (keydown.enter)="onOpportunityEnter(year, $event)" />

        <!-- Yearly Sales -->
        <input  *ngIf="form.get('sales_' + year)" type="text"
          [value]="getControl('sales_' + year) ? formatDecimalWithCommas(getControl('sales_' + year).value) : ''"
          disabled placeholder="Yearly Sales" />

        <!-- Notes -->
        <textarea *ngIf="form.get('notes_' + year)" [formControl]="getControl('notes_' + year)" placeholder="Notes"
          (keydown.enter)="onEnter(year, $event)"></textarea>
      </div>
    </div>
     <!-- Action Buttons -->
  <div class="button-col">
    <!-- <button class="recalculate" (click)="onRecalculate()" [disabled]="isLoading || areActionsDisabled" matTooltip="Check if the calculated final price exceeds the actual final price." matTooltipPosition="left">Validate</button> -->
    <button class="submit" (click)="onSubmit()" [disabled]="isLoading || areActionsDisabled" matTooltip="Save the updated Opportunity % changes." matTooltipPosition="left">Submit</button>
    <button class="cancel" (click)="onCancel()" [disabled]="areActionsDisabled" matTooltip="Discard any unsubmitted Opportunity % changes." matTooltipPosition="left">Cancel</button>
    <button class="cancel" (click)="onReset()" [disabled]="areActionsDisabled" matTooltip="Revert Opportunity % changes to their original values." matTooltipPosition="left">Reset</button>
  </div>
  </div>
 
  <!-- Spinner and Messages -->
  <div class="status-container">
    <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" [diameter]="30"></mat-progress-spinner>

    <div *ngIf="successMessage" class="success-message">
      {{ successMessage }}
      <button class="close-btn" (click)="clearMessages()">×</button>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
      <button class="close-btn" (click)="clearMessages()">×</button>
    </div>
  </div>
</div>